import { createContext, useContext } from 'react';

export type ModalContext = {
  show: boolean;
  onClose: () => void;

  purpose: 'default' | 'contextual';
  color: 'primary' | 'info' | 'success' | 'warning' | 'danger';
  size?: 'sm' | 'lg' | 'xl';
  border: boolean;
  shadow: boolean;
  backdrop: boolean | 'static';
  alignment: 'center' | 'top';
  fullScreen: boolean;
  scrolling: boolean;
};

export const ModalContext = createContext<ModalContext>({
  show: false,
  onClose: () => {},

  purpose: 'default',
  color: 'primary',
  size: undefined,
  border: false,
  shadow: true,
  backdrop: true,
  alignment: 'center',
  fullScreen: false,
  scrolling: false,
});

export const useModalContext = () => useContext(ModalContext);
